import { useAdminUpdate } from '@reapitform/hooks'
import { AdminActionTemplate, AdminActionTemplatePayload } from '../types'

/** Creates an action template under a form version
 * (`POST /api/forms/{formRef}/versions/{versionRef}/action-templates`). */
export const useCreateAdminActionTemplate = (formReferenceID: string, versionReferenceID: string) =>
  useAdminUpdate<AdminActionTemplatePayload, AdminActionTemplate>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/action-templates`,
    method: 'POST',
    errorMessage: 'Failed to create the action',
    successMessage: 'Action created',
  })
